export const container = {
  backgroundColor: (theme) => (theme.palette.mode === "dark" ? "rgba(51, 51, 51, 0.7)" : "rgba(255, 255, 255, 0.7)"),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
  padding: 2,
};

export const title = {
  fontSize: "2rem",
  fontWeight: "bold",
  marginBottom: 2,
};

export const inputField = (error) => ({
  "& .MuiOutlinedInput-root": {
    borderColor: error ? "red" : undefined,
  },
  "& .MuiFormHelperText-root": {
    color: "red",
  },
});

export const button = {
  background: "inherit",
  color: "white",
  padding: "10px 40px",
  borderRadius: "25px",
  position: "relative",
  overflow: "hidden",
  zIndex: 1,
  boxShadow: "0 0 5px rgba(255, 255, 255, 0.1), 0 0 10px rgba(255, 255, 255, 0.1)",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  
  "&:before": {
    content: '""',
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "300%",
    height: "300%",
    background: "linear-gradient(45deg, #00bcd4, #0000ff)", // темно-синий неоновый цвет
    borderRadius: "50%",
    transform: "translate(-50%, -50%) scale(0)",
    transition: "transform 0.5s ease",
    zIndex: -1,
    opacity: 0.7,
  },

  "&:hover": {
    transform: "scale(1.05)", // Увеличение кнопки при наведении
    boxShadow: "0 0 15px rgba(0, 188, 212, 0.6), 0 0 30px rgba(0, 0, 255, 0.6)", // добавляем неоновое свечение
  },

  "&:hover:before": {
    transform: "translate(-50%, -50%) scale(1)", // эффект расширения фона
  },
};


export const link = {
  marginTop: 15,
};
